import React, { Component, PropTypes } from 'react';

import SelectList from './SelectList';

export default class SelectListWithKeySupport extends Component {
  static propTypes = {
    onItemChange: PropTypes.func,
    type: PropTypes.string,
    elements: PropTypes.arrayOf(PropTypes.shape({
      unavailable: PropTypes.bool,
      checked: PropTypes.bool,
      value: PropTypes.any,
      name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      elements: PropTypes.array,
    })),
    appState: PropTypes.object,
    includeAllButton: PropTypes.bool,
    emptyElementsMessage: PropTypes.string,
    controlPosition: PropTypes.string,
    hasTextFilter: PropTypes.bool,
    activeIndex: PropTypes.number,
    activeItemIndex: PropTypes.number,
    reducedPadding: PropTypes.bool,
    darkerBlueHotelBackground: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      activeIndex: props.elements.findIndex(element => !element.unavailable),
    };
  }

  componentWillReceiveProps(props) {
    const { elements, activeItemIndex } = props;
    this.setState({
      activeIndex: activeItemIndex || elements.findIndex(element => !element.unavailable),
    });
  }

  selectNext = () => {
    this.setState({
      activeIndex: this.findNextAvailableElement(),
    });
  };

  selectPrevious = () => {
    this.setState({
      activeIndex: this.findPreviousAvailableElement(),
    });
  };

  findNextAvailableElement() {
    const { elements } = this.props;

    const nextAvailableElementIndex = elements.findIndex((element, index) =>
      index > this.state.activeIndex && !element.unavailable,
    );

    return nextAvailableElementIndex === -1 ? this.state.activeIndex : nextAvailableElementIndex;
  }

  findPreviousAvailableElement() {
    const { elements } = this.props;

    const previousAvailableElementIndex = [...elements].reverse().findIndex((element, index) =>
      (index >= (elements.length - this.state.activeIndex)) && !element.unavailable,
    );

    return previousAvailableElementIndex === -1 ? this.state.activeIndex : elements.length - previousAvailableElementIndex - 1;
  }

  render() {
    return <SelectList activeIndex={this.state.activeIndex} {...this.props} />;
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SelectList/SelectListWithKeySupport.jsx
 **/